import { Injectable } from '@angular/core';

@Injectable()
export class LocationHelper {
    public getCoordinates() {
        return new Promise<GeolocationCoordinates>((resolve, reject) => {
            const options: PositionOptions = {
                enableHighAccuracy: true,
            };

            const onSuccess = (position: GeolocationPosition) => resolve(position.coords);
            const onError = (error) => reject(error);

            navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
        });
    }

    public async hasPermission() {
        const permissionStatus = await navigator?.permissions?.query({ name: 'geolocation' });
        const hasPermission = permissionStatus.state === 'granted';

        return hasPermission;
    }

    public hasBrowserSupport() {
        return Boolean(navigator.geolocation);
    }
}
